// extracted by mini-css-extract-plugin
var _1 = "N4UYG0tOHSgsYthrRy6Y";
var _2 = "_PSrMtnqUl6cBFwLI0rP";
var _3 = "_7AydURN1JpVu7xi_4MF8";
var _4 = "ZyVr2dJ8mMyF6KGHXGi4";
export { _1 as "description", _2 as "details", _3 as "info", _4 as "name" }
